import { render } from "./DjiOutBoundOrderDetail.vue?vue&type=template&id=b5113832&scoped=true"
import script from "./DjiOutBoundOrderDetail.vue?vue&type=script&lang=js"
export * from "./DjiOutBoundOrderDetail.vue?vue&type=script&lang=js"

import "./DjiOutBoundOrderDetail.vue?vue&type=style&index=0&id=b5113832&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5113832"]])

export default __exports__